/* .576 Stránky sa načítavajú až keď treba (React.lazy) – v telefóne sa po
 * aktualizácii nesťahuje celý systém naraz (2,5 MB), len prehľad a to, čo sa otvorí. */
import { useEffect, useRef, useState, lazy, Suspense } from 'react';
import AiKredit from './components/AiKredit';
import PripomienkaObjednavok from './components/PripomienkaObjednavok';
import NoveProduktyPripomienka from './components/NoveProduktyPripomienka';
import PosledneFakturyLista from './components/PosledneFakturyLista';
import { Routes, Route, NavLink, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useObnovaPosunu } from './lib/spat';
import {
  LayoutDashboard, ArrowLeftRight, ShoppingCart, FileText, Users, Package, Settings as SettingsIcon, LogOut, Menu, X, PlusCircle, Truck, Wrench, BookOpen, TrendingUp, Target, CalendarClock, Inbox, Trophy, FileSignature, Cog, ScanLine, PackagePlus, PackageCheck, Handshake, Moon, Sun, Maximize2, Minimize2, Hand, Rss, Percent, Wallet, BarChart3, Receipt, Search as SearchIcon, PiggyBank, Store, ClipboardList, FlaskConical, Phone, Car, Bell,
} from 'lucide-react';
import RychlaAktualizacia from './components/RychlaAktualizacia';
import { api, getToken, setToken, today } from './api';
import { zapniTahanie, vypniTahanie } from './lib/dotykScroll';
import { celaObrazovka, zapamatajCelu } from './lib/celaObrazovka';
import { Loading } from './components/ui';
import ErrorBoundary from './components/ErrorBoundary';
import MiestoNaDisku from './components/MiestoNaDisku';

import MojProfil from './components/MojProfil';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TimOkno from './components/TimOkno';
import KtoVola from './components/KtoVola';
import SpodnaLista from './components/SpodnaLista';
import RychleHladanie from './components/RychleHladanie';

/* Po aktualizácii systému majú kúsky nové názvy – okno otvorené zo staršej verzie
 * by pri prvom otvorení stránky siahlo po neexistujúcom súbore. Vtedy sa stránka
 * raz sama obnoví (nie dokola). */
function lazyR(nacitaj) {
  return lazy(() => nacitaj().catch((e) => {
    try {
      if (!sessionStorage.getItem('fs_kusok')) { sessionStorage.setItem('fs_kusok', '1'); window.location.reload(); return new Promise(() => {}); }
    } catch { /* bez sessionStorage len chyba */ }
    throw e;
  }));
}


const PrijateFaktury = lazyR(() => import('./pages/PrijateFaktury'));
const Orders = lazyR(() => import('./pages/Orders'));
const OrderEdit = lazyR(() => import('./pages/OrderEdit'));
const Quotes = lazyR(() => import('./pages/Quotes'));
import MenuOdkazy from './components/MenuOdkazy';
import { TlacovaStanicaBeh } from './components/TlacovaStanica';
const QuoteEdit = lazyR(() => import('./pages/QuoteEdit'));
const Customers = lazyR(() => import('./pages/Customers'));
const Products = lazyR(() => import('./pages/Products'));
const Settings = lazyR(() => import('./pages/Settings'));
const Purchasing = lazyR(() => import('./pages/Purchasing'));
const Invoices = lazyR(() => import('./pages/Invoices'));
const ObjednavkyZPdf = lazyR(() => import('./pages/ObjednavkyZPdf'));
const Prijem = lazyR(() => import('./pages/Prijem'));
const Catalog = lazyR(() => import('./pages/Catalog'));
const Feedy = lazyR(() => import('./pages/Feedy'));
const Autoimport = lazyR(() => import('./pages/Autoimport'));
const HydroflexObjednavky = lazyR(() => import('./pages/HydroflexObjednavky'));
const Cenniky = lazyR(() => import('./pages/Cenniky'));
const Ziskovost = lazyR(() => import('./pages/Ziskovost'));
const DavkovanieChemie = lazyR(() => import('./pages/DavkovanieChemie'));
const Dielna = lazyR(() => import('./pages/Dielna'));
const Vyhladavanie = lazyR(() => import('./pages/Vyhladavanie'));
const Heureka = lazyR(() => import('./pages/Heureka'));
const Financie = lazyR(() => import('./pages/Financie'));
const PartnerVitajte = lazyR(() => import('./pages/PartnerVitajte'));
const FinancieRam = lazyR(() => import('./pages/Financie').then((m) => ({ default: m.FinancieRam })));
const FakturyPohoda = lazyR(() => import('./pages/FakturyPohoda'));
const NovaKarta = lazyR(() => import('./pages/NovaKarta'));
const Zarobky = lazyR(() => import('./pages/Zarobky'));
const Claims = lazyR(() => import('./pages/Claims'));
const Fakturacia = lazyR(() => import('./pages/Fakturacia'));
const Pomoc = lazyR(() => import('./pages/Pomoc'));
const Leady = lazyR(() => import('./pages/Leady'));
const LeadDetail = lazyR(() => import('./pages/LeadDetail'));
const FakturaEdit = lazyR(() => import('./pages/FakturaEdit'));
const ClaimNew = lazyR(() => import('./pages/ClaimNew'));
const ClaimDetail = lazyR(() => import('./pages/ClaimDetail'));
const Pozicovna = lazyR(() => import('./pages/Pozicovna'));
const Schranka = lazyR(() => import('./pages/Schranka'));
const Technik = lazyR(() => import('./pages/Technik'));
const TechnikZakazka = lazyR(() => import('./pages/Technik').then((m) => ({ default: m.TechnikZakazka })));
const TechnikQr = lazyR(() => import('./pages/Technik').then((m) => ({ default: m.TechnikQr })));
const Partner = lazyR(() => import('./pages/Partner'));
const Partneri = lazyR(() => import('./pages/Partneri'));
const PartnerNahlad = lazyR(() => import('./pages/PartnerNahlad'));
const Vykon = lazyR(() => import('./pages/Vykon'));
const ServisneZmluvy = lazyR(() => import('./pages/ServisneZmluvy'));
const StrojeZakaznikov = lazyR(() => import('./pages/StrojeZakaznikov'));
const Vozidla = lazyR(() => import('./pages/Vozidla'));
const Pripomienky = lazyR(() => import('./pages/Pripomienky'));
const ServisnaZmluvaDetail = lazyR(() => import('./pages/ServisnaZmluvaDetail'));
const Diely = lazyR(() => import('./pages/Diely'));
const Sklad = lazyR(() => import('./pages/Sklad'));
const Nazvy = lazyR(() => import('./pages/Nazvy'));
const Jednotky = lazyR(() => import('./pages/Jednotky'));
const RychlaInventura = lazyR(() => import('./pages/RychlaInventura'));
const Odbyt = lazyR(() => import('./pages/Odbyt'));
const AnalyzaPohody = lazyR(() => import('./pages/AnalyzaPohody'));
const Balenie = lazyR(() => import('./pages/Balenie'));
const RozvozTovaru = lazyR(() => import('./pages/RozvozTovaru'));
const StepSync = lazyR(() => import('./pages/StepSync'));
const Zasielky = lazyR(() => import('./pages/Zasielky'));
const Vykonnost = lazyR(() => import('./pages/Vykonnost'));
const Provizia = lazyR(() => import('./pages/Provizia'));
const Eshop = lazyR(() => import('./pages/Eshop'));

/* Kam sa obchodný zástupca dostane v prehliadači. Server to stráži tak či tak,
 * toto je len preto, aby po napísaní adresy nezostal na stránke, ktorá sa
 * donekonečna načítava. */
/* Objednávky sú v zozname zámerne: zástupca ich má vidieť, ale server mu
 * z nich vydá **len tie vlastné** (`routes/orders.js`). Cesta v menu je
 * pohodlie, hranicu drží server – schované tlačidlo sa dá obísť adresou. */
const OBCHODNIK_CESTY = ['/', '/leady', '/ponuky', '/objednavky', '/servisne-zmluvy', '/stroje-zakaznikov',
  '/katalogy', '/tovar', '/navod', '/davkovanie'];
/* Výnimky vnútri povolených ciest. Cenový rebrík sa presťahoval do dielne
 * (`/dielna/rebrik`, a tá je len pre administrátora), ale stará adresa ostáva
 * ako presmerovanie – zástupca sa k nej nemá dostať ani cez ňu. */
const OBCHODNIK_ZAKAZ = ['/tovar/ceny'];
/**
 * Marketér je človek mimo firmy a má presne dve obrazovky.
 *
 * Zoznam je **povolených ciest**, nie zakázaných: keď o pol roka pribudne nová
 * sekcia, sama sa mu neotvorí. Návod je v ňom preto, že bez neho by nemal kde
 * hľadať, čo tie čísla znamenajú.
 */
const MARKETER_CESTY = ['/financie', '/ziskovost', '/zarobky', '/navod'];
/* .552 Účtovníčka: jediná obrazovka – prijaté faktúry (archív originálov). */
const UCTOVNIK_CESTY = ['/prijate-faktury'];
/** Cesty len pre administrátora – aj keď si ich niekto napíše do adresy. */
const LEN_ADMIN = ['/nastavenia', '/vykon', '/sklad', '/partneri', '/financie', '/ziskovost', '/zarobky',
  '/dielna', '/nova-karta', '/heureka', '/stepsync', '/vyhladavanie', '/pripomienky'];
const smieNaCestu = (role, cesta, skryte = []) => {
  /* Skrytá sekcia sa nemá dať otvoriť ani napísaním adresy – inak by skrytie
   * v menu bolo len odporúčanie. Nie je to zámok na údaje (tie strážia
   * menovité práva pri dokladoch, schránke a cenách), ale nikto sa tam
   * neocitne omylom ani zo zvedavosti. */
  if (skryte.some((c) => c && (cesta === c || (c !== '/' && cesta.startsWith(`${c}/`))))) return false;
  /* Marketér sa rieši pred `LEN_ADMIN`: dve z tých ciest sú práve tie, kvôli
   * ktorým konto existuje. Všetko ostatné mu ostáva zavreté. */
  if (role === 'marketer') {
    return MARKETER_CESTY.some((c) => cesta === c || cesta.startsWith(`${c}/`));
  }
  if (role === 'uctovnik') {
    return UCTOVNIK_CESTY.some((c) => cesta === c || cesta.startsWith(`${c}/`));
  }
  if (LEN_ADMIN.some((c) => cesta === c || cesta.startsWith(`${c}/`))) return role === 'admin';
  return role !== 'obchodnik'
    || (OBCHODNIK_CESTY.some((c) => cesta === c || cesta.startsWith(`${c}/`))
      && !OBCHODNIK_ZAKAZ.some((c) => cesta === c || cesta.startsWith(`${c}/`)));
};

/**
 * Ťahanie prstom po obrazovke.
 *
 * Displej pri baliacom stole je **jednodotykový** a Windows ho nehlási ako
 * dotykové zariadenie, ale ako myš s absolútnou polohou. Prehliadač preto
 * nemá čo posúvať – ťahanie po obrazovke je pre neho označovanie textu a
 * ostane iba tenký posuvník na kraji, ktorý sa prstom trafí ťažko.
 *
 * Zapína sa **pre tento počítač**, nie pre človeka: pri stole sa ťahá prstom,
 * v kancelárii sa tou istou myšou označuje text a ťahanie by tam prekážalo.
 * Rovnaké pravidlo ako pri nočnom režime.
 */
export function useDotykoveTahanie() {
  const [dotyk, setDotyk] = useState(() => {
    try { return localStorage.getItem('fs_dotyk') === '1'; } catch { return false; }
  });
  useEffect(() => {
    if (dotyk) zapniTahanie(); else vypniTahanie();
    try { localStorage.setItem('fs_dotyk', dotyk ? '1' : '0'); } catch { /* súkromné okno */ }
    return () => vypniTahanie();
  }, [dotyk]);
  return [dotyk, setDotyk];
}

/**
 * Nočný režim.
 *
 * Drží sa v prehliadači, nie pri používateľovi: baliaci stôl svieti do očí
 * v sklade, kým ten istý človek na kancelárskom počítači chce svetlo.
 */
export function useNocnyRezim() {
  const [nocny, setNocny] = useState(() => {
    try { return localStorage.getItem('fs_nocny') === '1'; } catch { return false; }
  });
  useEffect(() => {
    document.documentElement.classList.toggle('nocny', nocny);
    try { localStorage.setItem('fs_nocny', nocny ? '1' : '0'); } catch { /* súkromné okno */ }
  }, [nocny]);
  return [nocny, setNocny];
}

/**
 * Deň, na ktorý je stôl prihlásený.
 *
 * ── Prečo sa stôl hlási každé ráno ───────────────────────────────────────
 * Prihlásenie samo o sebe drží tridsať dní, takže by sa kiosk po zapnutí
 * otvoril rovno do objednávok a kód by nikto nikdy nezadal. Pri konte, ktoré
 * je spoločné, je ale **raz denne zadať kód** správna miera: je to gesto
 * začiatku zmeny, po ktorom je jasné, že stôl niekto prevzal – a zároveň to
 * nikoho nevyhodí uprostred balenia, keď sa Chrome cez deň reštartuje.
 *
 * Drží sa to v prehliadači, nie na serveri: je to vlastnosť tohto počítača
 * pri tomto stole, nie vlastnosť konta.
 */
const KLUC_DNA = 'fs_stol_den';
export const denStola = () => {
  try { return localStorage.getItem(KLUC_DNA); } catch { return null; }
};
export const zapisDenStola = () => {
  try { localStorage.setItem(KLUC_DNA, today()); } catch { /* súkromné okno */ }
};

/* Celá obrazovka má vlastný súbor (`lib/celaObrazovka.js`) – používa ju aj
 * baliaci stôl a obojsmerný import medzi obrazovkou a App by bol zbytočný uzol. */
export { celaObrazovka, chceCeluObrazovku, zapamatajCelu } from './lib/celaObrazovka';

/** Ako sa rola volá pre človeka. */
const ROLA_POPIS = {
  admin: 'Administrátor',
  user: 'Používateľ',
  obchodnik: 'Obchodný zástupca',
  marketer: 'Marketér',
  uctovnik: 'Účtovníčka',
};

/* `role` obmedzuje, komu sa položka v menu ukáže. Bez `role` ju vidí každý
 * okrem obchodného zástupcu – ten má vlastný krátky zoznam. Skrytie v menu je
 * len pohodlie; skutočnú hranicu drží server (server/src/pristup.js). */
export const NAV = [
  /* Oto: „Aký je rozdiel medzi sekciou Prehľad a Prehľad predaja? Nebolo by to
     dobré zjednotiť iba na Prehľad a dať to ako prvé?"

     Bolo. „Prehľad predaja" sa v tretine prekrýval s nástenkou (úlohy z leadov,
     ponuky čakajúce na odpoveď, graf po mesiacoch) a zvyšok — výsledovka
     človeka a porovnanie kolegov — je odteraz kartami „Môj predaj",
     „Moje leady" a „Ponuky verzus objednávky". Sekcia zanikla, adresa ostala
     funkčná a presmeruje sem.

     A domovská obrazovka patrí navrch. Bola siedma. */
  { to: '/', label: 'Prehľad', icon: LayoutDashboard, end: true,
    role: ['admin', 'user', 'obchodnik', 'marketer'] },
  /* .1002 Oto: „aby som nezabudol, prepisoval by si mi SMS do pripomienkovača v CRM" */
  { to: '/pripomienky', label: 'Pripomienky', icon: Bell, role: ['admin'] },
  { to: '/leady', label: 'Lead management', icon: Target, role: ['admin', 'obchodnik'] },
  /* .797 Oto: „Zisk a marže, Zárobky a výdaje, Cenovú dielňu a Heureku daj
     do jedného." Jedna položka – rozcestník s dlaždicami; samotné sekcie
     majú navrchu lištu, ktorou sa medzi nimi prepína. `aj` = cesty, pri
     ktorých je položka v menu zvýraznená. */
  { to: '/financie', label: 'Price Management', icon: PiggyBank, role: ['admin', 'marketer'],
    aj: ['/ziskovost', '/zarobky', '/dielna', '/heureka', '/vyhladavanie'] },
  /* .552 Účtovníčka vidí len toto. Ostatní majú to isté v Príjme tovaru → Archív. */
  { to: '/prijate-faktury', label: 'Prijaté faktúry', icon: FileText, role: ['uctovnik'] },
  { to: '/objednavky', label: 'Objednávky', icon: ShoppingCart,
    role: ['admin', 'user', 'obchodnik'] },
  /* Oto: „Spravme to všetko v novej sekcii FAKTÚRY POHODA." Vydané faktúry
     z účtovníctva, čo z nich ostáva uhradiť a upomienky (.429). */
  { to: '/faktury-pohoda', label: 'Faktúry POHODA', icon: Receipt, role: ['admin', 'user'] },
  { to: '/ponuky', label: 'Cenové ponuky', icon: FileText, role: ['admin', 'user', 'obchodnik'] },
  { to: '/schranka', label: 'Schránka', icon: Inbox, flag: 'schranka' },
  { to: '/na-objednanie', label: 'Na objednanie', icon: Truck },
  /* .844 Oto: objednávky e-shopu + ručne → priamo objednať u Hydroflex (API). */
  { to: '/hydroflex', label: 'Objednávky Hydroflex', icon: ShoppingCart, flag: 'hydroflex' },
  /* Príjem faktúr už nie je samostatná zastávka v menu: faktúra je prvý krok
   * dodávky a patrí tam, kde sa dodávka preberá. Adresa ostáva funkčná –
   * archív dokladov, ich detail a opravy sú stále tam a odkazy naň fungujú
   * ďalej; len sa preň nechodí cez menu. */
  /* Príjem tovaru je sprievodca pre skladníka: faktúra, napípanie, kontrola,
   * objednávky, príjemka. Preto ho vidí aj zamestnanec – je to jeho práca.
   * Zápisy v ňom (objednávky, príjemka) si strážia vlastné práva. */
  { to: '/prijem-tovaru', label: 'Príjem tovaru', icon: PackagePlus, role: ['admin', 'user'] },
  /* Baliaci stôl je druhá polovica tej istej práce: čo sa prijalo, sa aj
   * vyskladní. Vidí ho zamestnanec, obchodný zástupca nie. */
  { to: '/balenie', label: 'Baliaci stôl', icon: PackageCheck, role: ['admin', 'user'] },
  /* Oto: „Sprav v menu novú sekciu Rozvoz tovaru – tovar, ktorý nesieme
     osobne; šofér ho tam vybaví a vystaví len CRM faktúru." (.599) */
  { to: '/rozvoz-tovaru', label: 'Rozvoz tovaru', icon: Truck, role: ['admin', 'user'] },
  /* StepSync – náhrada ShopSyncu (.605). Zatiaľ len pre administrátora. */
  { to: '/stepsync', label: 'StepSync', icon: ArrowLeftRight, role: ['admin'] },
  /* Oto: „Chceli by sme pomaly úplne vynechávať Shoptet rozhranie … taká
   * premakaná sekcia, odkiaľ skladníci budú vedieť perfektne ovládať celý
   * e-shop." (.479) Zatiaľ ju vidí administrátor a tí, ktorým ju sprístupní
   * v jej Nastaveniach – `flag` ide z /me, hranicu drží server. */
  /* .798 ESHOP nie je v zozname – je to zelená dlaždica hore pod „Nová
   * objednávka / Nová ponuka" (`dlazdica`). V NAV ostáva kvôli skrývaniu
   * sekcií v nastaveniach používateľa. */
  { to: '/eshop', label: 'ESHOP', icon: Store, flag: 'eshop', dlazdica: true },
  { to: '/servis', label: 'Reklamácie a servis', icon: Wrench },
  { to: '/servisne-zmluvy', label: 'Servisné zmluvy', icon: FileSignature, role: ['admin', 'user', 'obchodnik'] },
  /* .779 Oto: „novú časť v menu – budeme evidovať zákazníkov, ktorí majú také
     stroje, a posielať im správy po kúpe, aktualizovať a oslovovať ich." */
  { to: '/stroje-zakaznikov', label: 'Stroje zákazníkov', icon: ClipboardList, role: ['admin', 'user', 'obchodnik'] },
  { to: '/pozicovna', label: 'Požičovňa', icon: CalendarClock },
  /* .956 Oto: „kategóriu diaľničné známky a kompletný SMS a mail upozorňovací systém" – naše autá, STK, EK, PZP. */
  { to: '/vozidla', label: 'Vozidlá a známky', icon: Car, role: ['admin', 'user'] },
  { to: '/katalogy', label: 'Katalógy', icon: BookOpen, role: ['admin', 'user', 'obchodnik'] },
  /* .904 Oto: „kalkulačku na dávkovanie chémie od zn. Kärcher" – riedenie
     z produktových listov Kärcher, pre predajňu aj obchodníka v teréne. */
  { to: '/davkovanie', label: 'Dávkovanie chémie', icon: FlaskConical, role: ['admin', 'user', 'obchodnik'] },
  /* Feedy sú druhá polovica katalógov: katalóg tovar dodávateľa stiahne,
   * feedy rozhodujú, čo z neho ide na e-shop a za koľko. Rozhoduje sa tu
   * o predajných cenách, preto to nevidí obchodný zástupca. */
  /* Autoimport (.530) nahrádza Feedy: spojky feedov dodávateľov na e-shop.
   * Staré Feedy ostávajú dostupné cez odkaz v Autoimporte do prechodu. */
  { to: '/autoimport', label: 'Autoimport', icon: Rss, role: ['admin'] },
  /* Oficiálne cenníky výrobcu. Nesú cenníkovú cenu a hovoria, čo je profi
   * a čo hobby sortiment – od toho závisí rabatový bonus. */
  { to: '/cenniky', label: 'Cenníky', icon: BookOpen, role: ['admin', 'user'] },
  { to: '/diely', label: 'Náhradné diely', icon: Cog },
  { to: '/zakaznici', label: 'Zákazníci', icon: Users },
  /* B2B partneri: cudzie firmy s vlastným prihlásením a vlastným cenníkom.
   * Rozhoduje sa tu o cenách, za ktoré predávame – preto len administrátor. */
  { to: '/partneri', label: 'B2B partneri', icon: Handshake, role: ['admin'] },
  { to: '/tovar', label: 'Tovar', icon: Package, role: ['admin', 'user', 'obchodnik'] },
  /* Nastavenia sú len pre administrátora – sú v nich ceny, prístupy
   * a napojenia, ktoré pokazia prácu všetkým naraz. Zamestnanec si svoje
   * veci (heslo, podpis do mailov) nastaví v Mojom profile dole. */
  /* Skener skladu sa zatiaľ skúša – kým sa nevie, či postup v sklade sadne,
   * nemá sa objaviť kolegom v menu. */
  { to: '/sklad', label: 'Skener skladu', icon: ScanLine, role: ['admin'] },
  { to: '/vykon', label: 'Výkon zamestnancov', icon: Trophy, role: ['admin'] },
  { to: '/nastavenia', label: 'Nastavenia', icon: SettingsIcon, role: ['admin'] },
];

/**
 * Značka nad menu.
 *
 * Logo sa berie zo súboru, ktorý si systém odkladá medzi nahraté – nie
 * z nastavení, aby sa menu vykreslilo hneď a nečakalo na žiadne volanie.
 * Keby súbor chýbal (stará inštalácia, ručne zmazané), ostane pôvodný nápis;
 * menu tak nikdy neostane prázdne.
 */
function Znacka() {
  const [maLogo, setMaLogo] = useState(true);

  if (!maLogo) {
    return (
      <div className="flex items-center gap-2">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-600 font-bold text-white">S</div>
        <div className="leading-tight">
          <div className="text-sm font-semibold text-white">Firemný systém</div>
          <div className="text-[11px] text-slate-400">objednávky &amp; ponuky</div>
        </div>
      </div>
    );
  }

  return (
    <div className="leading-tight">
      <img src="/uploads/logo-steps-biele.png" alt="STEPS STORE"
        className="h-8 w-auto" onError={() => setMaLogo(false)} />
      <div className="mt-1.5 text-[11px] tracking-wide text-slate-400">objednávky &amp; ponuky</div>
    </div>
  );
}

export default function App() {
  const [kto, nastavKto] = useState(null);
  /* Číslo prihláseného sa odkladá vedľa – filtre v zoznamoch sa podľa neho
   * pamätajú zvlášť pre každého, kto za tým počítačom sedí (`pamatFiltra.js`).
   * Zapisuje sa **hneď**, nie cez `useEffect`: obrazovky si pamäť čítajú pri
   * prvom vykreslení a to je skôr, než by efekt v App stihol bežať. */
  const setUser = (u) => {
    try {
      if (u?.id) localStorage.setItem('fs_user', String(u.id));
      else localStorage.removeItem('fs_user');
    } catch { /* súkromné okno */ }
    nastavKto(u);
  };
  const user = kto;
  const [loading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const [nocny, setNocny] = useNocnyRezim();
  const [dotyk, setDotyk] = useDotykoveTahanie();
  const [naCelu, setNaCelu] = useState(false);
  const [profil, setProfil] = useState(false);
  const [hladanie, setHladanie] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();
  /* Späť vráti aj na to miesto zoznamu, kde človek bol (.498). */
  useObnovaPosunu();

  /* Domovská stránka (.497) – len kam ho pustí po prihlásení. Tlačidlo Späť
   * sa nemení: vracia vždy o jednu obrazovku (Oto, .498). */
  const domov = kto?.domov && smieNaCestu(kto.role, kto.domov, kto.skryte_sekcie || []) ? kto.domov : null;

  /* Mal už tento počítač povedané, ako to chce?
   *
   * Číta sa **pri prvom vykreslení**, teda skôr, než si `useNocnyRezim`
   * a `useDotykoveTahanie` stihnú do pamäte prehliadača zapísať svoje „nie".
   * Bez toho by sa nedalo rozoznať „vypnuté, lebo tak sa to rozhodlo" od
   * „vypnuté, lebo sa o tom ešte nikto nerozhodoval" – a stôl by si vlastné
   * nastavenie prepisoval každé ráno. */
  const predvolbyBoli = useRef(null);
  if (predvolbyBoli.current === null) {
    try {
      predvolbyBoli.current = {
        nocny: localStorage.getItem('fs_nocny') !== null,
        dotyk: localStorage.getItem('fs_dotyk') !== null,
      };
    } catch { predvolbyBoli.current = { nocny: true, dotyk: true }; }
  }

  /* Stôl začína v tme a s ťahaním prstom.
   *
   * Nie natvrdo – **len keď sa o tom na tomto počítači ešte nerozhodovalo**.
   * Tlačidlá v lište potom fungujú a ich voľba drží; keby sa to vnucovalo pri
   * každom vykreslení, boli by to tlačidlá, ktoré nič nerobia. */
  useEffect(() => {
    if (user?.role !== 'balenie') return;
    if (!predvolbyBoli.current.nocny) setNocny(true);
    if (!predvolbyBoli.current.dotyk) setDotyk(true);
  }, [user?.role, setNocny, setDotyk]);

  useEffect(() => {
    if (!getToken()) { setLoading(false); return; }
    api.me()
      .then((u) => {
        /* Stôl sa hlási raz za deň. Nie je to bezpečnostné opatrenie – kód
         * pozná celý sklad –, je to gesto začiatku zmeny. */
        if (u?.role === 'balenie' && denStola() !== today()) { setToken(null); return; }
        setUser(u);
      })
      .catch(() => setToken(null))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { setMenuOpen(false); }, [loc.pathname]);

  /* Tlačidlo má ukazovať skutočnosť: z celej obrazovky sa dá odísť aj
   * klávesou Esc alebo F11, o čom by inak stránka nevedela. */
  useEffect(() => {
    const zmena = () => {
      const je = !!document.fullscreenElement;
      setNaCelu(je);
      /* Odchod z celej obrazovky je rozhodnutie človeka – či ho spravil
         klávesou Esc, F11 alebo tlačidlom, je jedno. Zapamätá sa tu, na
         jednom mieste, aby ho nemusel robiť trikrát. */
      zapamatajCelu(je);
    };
    document.addEventListener('fullscreenchange', zmena);
    return () => document.removeEventListener('fullscreenchange', zmena);
  }, []);

  if (loading) return <Loading />;

  if (!user) {
    return (
      <Suspense fallback={<Loading />}>
      <Routes>
        {/* Po prihlásení sa ostáva tam, kam človek smeroval – inak by odkaz
            z QR kódu na servisnom liste vždy skončil na úvodnej obrazovke. */}
        {/* Keď sa na prihlásenie prišlo z adresy baliaceho stola, ukáže sa
            rovno číselnica stola. Práve na túto adresu sa po zapnutí počítača
            otvára kiosk – nikto pri stole nemá čo vyberať z ponuky, ako sa
            prihlási. Odkaz na bežné prihlásenie je pod ňou. */}
        {/* .802 stránka z uvítacieho mailu B2B partnera – registrácia bez prihlásenia */}
        <Route path="/partner/vitajte/:token" element={<PartnerVitajte onLogin={(u) => {
          setUser(u);
          api.me().then((f) => { if (f) setUser(f); }).catch(() => {});
        }} />} />
        <Route path="*" element={<Login stol={loc.pathname.startsWith('/balenie')} onLogin={(u) => {
          if (u?.role === 'balenie') zapisDenStola();
          setUser(u);
          /* .729 celé údaje (aj „len ESHOP") – prihlásenie vracia len meno a rolu */
          api.me().then((f) => { if (!f) return; setUser(f); if (f.len_eshop) nav('/eshop', { replace: true }); }).catch(() => {});
          const ciel = loc.pathname.startsWith('/technik') || loc.pathname.startsWith('/partner')
            ? loc.pathname : null;
          nav(ciel || ({ technik: '/technik', partner: '/partner', balenie: '/balenie', marketer: '/ziskovost', uctovnik: '/prijate-faktury' })[u.role] || '/',
            { replace: true });
        }} />} />
      </Routes>
      </Suspense>
    );
  }

  /* Odhlásenie vracia stôl na stôl, nie na všeobecné prihlásenie: kiosk má
   * ukázať zase tú istú číselnicu, nie obrazovku so serverom a e-mailom. */
  const logout = () => {
    const bolStol = user?.role === 'balenie';
    setToken(null);
    setUser(null);
    nav(bolStol ? '/balenie' : '/prihlasenie');
  };

  /* Baliaci stôl beží na dotykovom displeji pri stole: menu ani hlavička tam
   * nemajú čo robiť, obrazovka patrí objednávke. Menu sa dá kedykoľvek
   * vysunúť tlačidlom. */
  /* .807 Oto: „baliaci stôl nech sa po otvorení u mňa (u admina)
   * nemaximalizuje na celú obrazovku, nech mi ostane viditeľné aj menu."
   * Kiosk (bez menu, celá obrazovka) ostáva pre ostatných pri stole. */
  const stolAdmin = user?.role === 'admin';
  const kiosk = loc.pathname.startsWith('/balenie') && !stolAdmin;

  /* Externý servisný technik má vlastnú stránku bez menu a bez zvyšku CRM.
   * Nie je to náš zamestnanec – rozhranie mu preto ani neukazuje, že tu niečo
   * ďalšie je. */
  /* B2B partner má tiež vlastnú stránku bez menu a bez zvyšku CRM – je to
   * cudzia firma, nie náš človek. Rozhranie mu ani neukazuje, že tu niečo
   * ďalšie je. */
  if (user.role === 'partner') {
    return (
      <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/partner" element={<Partner user={user} onLogout={logout} />} />
        <Route path="*" element={<Navigate to="/partner" replace />} />
      </Routes>
      </Suspense>
    );
  }

  if (user.role === 'technik') {
    return (
      <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/technik" element={<Technik user={user} onLogout={logout} />} />
        <Route path="/technik/z/:token" element={<TechnikQr user={user} onLogout={logout} />} />
        <Route path="/technik/:id" element={<TechnikZakazka user={user} onLogout={logout} />} />
        <Route path="*" element={<Navigate to="/technik" replace />} />
      </Routes>
      </Suspense>
    );
  }

  /* Konto samotného baliaceho stola.
   *
   * Nie je to človek, je to miesto: dotykový displej pri páse, na ktorom sa
   * strieda, kto má práve čas, a heslo k nemu pozná celý sklad. Preto tu nie
   * je menu, ktoré by sa dalo vysunúť – nie je kam ísť. Namiesto neho je
   * v lište odhlásenie, aby sa stôl dal na konci zmeny zavrieť.
   *
   * Pri stole má naopak plné právo: server mu ho drží zoznamom povolených
   * ciest, nie rolou, takže delené právo pri stole ani nevzniká. */
  if (user.role === 'balenie') {
    return (
      <div className="pb-28">{/* .840 miesto pod plávajúce tlačidlá vľavo dole */}
      <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/balenie" element={
          <Balenie
            user={user}
            onOdhlasit={logout}
            nocny={nocny}
            onNocny={() => setNocny((x) => !x)}
            dotyk={dotyk}
            onDotyk={() => setDotyk((x) => !x)}
            naCelu={naCelu}
            onCelu={() => celaObrazovka(!naCelu)}
          />} />
        <Route path="*" element={<Navigate to="/balenie" replace />} />
      </Routes>
      </Suspense>
      </div>
    );
  }

  /* .729 Zjednodušené rozhranie (Mirka): po prihlásení rovno ESHOP, bez menu.
   * Namiesto menu je malý prepínač ESHOP ↔ Baliaci stôl a odhlásenie.
   * Nastavuje sa v Nastavenia → Používatelia („Len ESHOP a baliaci stôl"). */
  if (user.len_eshop) {
    const naStole = loc.pathname.startsWith('/balenie');
    const prepinac = (
      <div className={`flex items-center gap-1 rounded-xl bg-slate-900 p-1 text-sm font-bold text-white shadow-lg no-print ${naStole ? 'fixed bottom-3 left-3 z-50' : ''}`}>
        <button className={`rounded-lg px-3 py-1.5 ${!naStole ? 'bg-emerald-600' : 'hover:bg-slate-700'}`} onClick={() => nav('/eshop')}>ESHOP</button>
        <button className={`rounded-lg px-3 py-1.5 ${naStole ? 'bg-emerald-600' : 'hover:bg-slate-700'}`} onClick={() => nav('/balenie')}>Baliaci stôl</button>
        <span className="hidden px-2 text-xs font-normal text-slate-300 sm:inline">{user.name}</span>
        <button className="rounded-lg px-2 py-1.5 text-xs font-normal text-slate-300 hover:bg-slate-700" onClick={logout} title="Odhlásiť">Odhlásiť</button>
      </div>
    );
    return (
      <div className="min-h-screen">
        {!naStole && <div className="flex justify-end px-4 pt-3 sm:px-6">{prepinac}</div>}
        {naStole && prepinac}
        {/* .840 pb-32: plávajúci prepínač a tlačidlo „Čo vieme o tovare“ vľavo dole
            zakrývali spodné tlačidlá dlaždice – dá sa doscrollovať nad ne. */}
        <main className={naStole ? 'max-w-none p-3 pb-32' : 'mx-auto max-w-[1400px] p-4 pt-2 sm:px-6'}>
          <ErrorBoundary kluc={loc.pathname}>
          <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/eshop/*" element={<Eshop />} />
            <Route path="/balenie" element={
              <Balenie user={user} onMenu={() => nav('/eshop')} nocny={nocny} onNocny={() => setNocny((x) => !x)}
                dotyk={dotyk} onDotyk={() => setDotyk((x) => !x)} naCelu={naCelu} onCelu={() => celaObrazovka(!naCelu)} />} />
            <Route path="*" element={<Navigate to="/eshop" replace />} />
          </Routes>
          </Suspense>
          </ErrorBoundary>
        </main>
        {/* .875 Oto: „Mirka nemá naboku vysúvaciu lištu s faktúrami" – v zjednodušenom
            rozhraní (len ESHOP) chýbala; na ESHOPe áno, na baliacom stole nie. */}
        {!naStole && <PosledneFakturyLista predvolene="vlavo" />}
      </div>
    );
  }

  return (
    <div className="min-h-screen lg:flex">
      {/* bočné menu */}
      {/* Menu je vlastný stĺpec na celú výšku obrazovky: hore značka, v strede
          odkazy (tie sa v prípade potreby posúvajú samy) a dole blok, ktorý
          musí byť vidieť vždy – Fakturácia, meno a odhlásenie. Kým bol dolný
          blok `absolute`, na dlhých stránkach sa ukotvil až na koniec
          dokumentu a bolo ho treba nascrollovať. */}
      <aside
        className={`fixed inset-y-0 left-0 z-40 flex w-64 shrink-0 flex-col border-r border-slate-800 bg-slate-900 text-slate-300 transition-transform no-print ${
          kiosk ? '' : 'lg:sticky lg:inset-y-auto lg:top-0 lg:h-screen lg:translate-x-0'
        } ${menuOpen ? 'translate-x-0' : '-translate-x-full'}`}
      >
        <div className="flex h-[72px] items-center gap-3 px-5">
          <Znacka />
          <button className={`ml-auto text-slate-400 ${kiosk ? '' : 'lg:hidden'}`}
            onClick={() => setMenuOpen(false)}><X size={20} /></button>
        </div>

        {/* .798 Oto: „hore dve červené dlaždice vedľa seba – nová objednávka
            a nová cenová ponuka, pod to širokú zelenú ESHOP." */}
        <div className="space-y-2 px-3 pb-3">
          {['marketer', 'uctovnik'].includes(user.role) ? null : (
            <div className={`grid gap-2 ${user.role === 'obchodnik' && !user.objednavky_vsetky ? 'grid-cols-1' : 'grid-cols-2'}`}>
              {/* Obchodný zástupca objednávky nepíše – má len novú ponuku (.833 okrem práva „všetky objednávky"). */}
              {(user.role !== 'obchodnik' || !!user.objednavky_vsetky) && (
                <button onClick={() => nav('/objednavky/nova')} title="Nová objednávka"
                  className="flex items-center gap-1.5 rounded-lg bg-gradient-to-br from-brand-500 to-brand-700 px-2 py-1.5 text-left text-white shadow-sm ring-1 ring-brand-400/40 transition hover:from-brand-400 hover:to-brand-600 hover:shadow-md">
                  <ShoppingCart size={15} className="shrink-0" />
                  <span className="text-[11.5px] font-semibold leading-[1.15]">Nová<br />objednávka</span>
                </button>
              )}
              <button onClick={() => nav('/ponuky/nova')} title="Nová cenová ponuka"
                className="flex items-center gap-1.5 rounded-lg bg-gradient-to-br from-brand-500 to-brand-700 px-2 py-1.5 text-left text-white shadow-sm ring-1 ring-brand-400/40 transition hover:from-brand-400 hover:to-brand-600 hover:shadow-md">
                <FileText size={15} className="shrink-0" />
                <span className="text-[11.5px] font-semibold leading-[1.15]">Nová<br />ponuka</span>
              </button>
            </div>
          )}
          {!!user.eshop && !(user.skryte_sekcie || []).includes('/eshop') && (
            <NavLink to="/eshop"
              className={({ isActive }) => `flex items-center gap-3 rounded-xl px-3 py-2 text-white shadow-sm ring-1 transition ${isActive
                ? 'bg-gradient-to-r from-sky-400 to-sky-500 ring-sky-200'
                : 'bg-gradient-to-r from-sky-500 to-sky-600 ring-sky-400/40 hover:from-sky-400 hover:to-sky-500 hover:shadow-md'}`}>
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/15"><Store size={18} /></span>
              <span className="leading-tight">
                <span className="block text-base font-bold tracking-wide">ESHOP</span>
                <span className="block text-[11px] text-sky-100">akciovenaradie.sk</span>
              </span>
            </NavLink>
          )}
          {/* .925 externé odkazy (NotebookLM…) – hore, nech sa nestratia na konci menu */}
          <MenuOdkazy user={user} />
        </div>

        <nav className="flex-1 space-y-1 overflow-y-auto px-3 pb-3">
          {/* Rola hovorí, čo sa smie; `skryte_sekcie` hovorí, čo tento
              konkrétny človek vidieť nemá. Je to zoznam skrytých, nie
              povolených – nová sekcia sa tak nikomu nestratí len preto, že
              o nej staré nastavenie nevie. */}
          {NAV
            .filter((n) => (n.flag ? !!user[n.flag] : n.role ? n.role.includes(user.role) : user.role !== 'obchodnik'))
            .filter((n) => !(user.skryte_sekcie || []).includes(n.to))
            .filter((n) => !n.dlazdica)
            /* Externé kontá s vlastným zoznamom ciest vidia v menu len to. */
            .filter((n) => !['marketer', 'uctovnik'].includes(user.role) || smieNaCestu(user.role, n.to))
            .map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              onClick={n.to === '/balenie' && user.role !== 'admin' ? () => celaObrazovka(true) : undefined}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors ${
                  isActive || (n.aj || []).some((c) => loc.pathname === c || loc.pathname.startsWith(`${c}/`))
                    ? 'bg-slate-800 text-white' : 'hover:bg-slate-800/60 hover:text-white'
                }`
              }
            >
              <n.icon size={18} /> {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-auto border-t border-slate-800 p-3">
          {/* Fakturácia je vlastný svet – nepatrí medzi denné sekcie hore.
              V rohu má len kockaté „F", nech nezaberá miesto a predsa je po ruke. */}
          <div className="mb-3 flex gap-2">
          {!['obchodnik', 'marketer', 'uctovnik'].includes(user.role) && (
          <NavLink to="/fakturacia" title="Fakturácia"
            className={({ isActive }) =>
              `flex h-9 w-9 items-center justify-center rounded-lg text-sm font-bold ring-1 transition-colors ${
                isActive
                  ? 'bg-brand-600 text-white ring-brand-500'
                  : 'bg-slate-800 text-slate-300 ring-slate-700 hover:bg-slate-700 hover:text-white'
              }`}>
            F
          </NavLink>
          )}

          {/* Zásielky – balík mimo objednávky. Vedľa „F" a „?", lebo je to
              rovnaký druh veci: po ruke, ale nie denná sekcia. Ikona balíka
              namiesto písmena – zásielka sa nedá pomenovať jedným znakom. */}
          {!['obchodnik', 'marketer', 'uctovnik'].includes(user.role) && (
          <NavLink to="/zasielky" title="Zásielky – balík mimo objednávky"
            className={({ isActive }) =>
              `flex h-9 w-9 items-center justify-center rounded-lg ring-1 transition-colors ${
                isActive
                  ? 'bg-brand-600 text-white ring-brand-500'
                  : 'bg-slate-800 text-slate-300 ring-slate-700 hover:bg-slate-700 hover:text-white'
              }`}>
            <PackagePlus size={18} />
          </NavLink>
          )}

          {/* Návod je vedľa – rovnako malý, nech je po ruke a nezaberá menu. */}
          <NavLink to="/navod" title="Návod pre zamestnancov"
            className={({ isActive }) =>
              `flex h-9 w-9 items-center justify-center rounded-lg text-sm font-bold ring-1 transition-colors ${
                isActive
                  ? 'bg-brand-600 text-white ring-brand-500'
                  : 'bg-slate-800 text-slate-300 ring-slate-700 hover:bg-slate-700 hover:text-white'
              }`}>
            ?
          </NavLink>

          {/* .909 Kto volá? – číslo napísať ručne; pri napojenom mobile okienko vyskočí samo. */}
          {['admin', 'user'].includes(user.role) && (
            <button title="Kto volá? – vyhľadať telefónne číslo"
              onClick={() => window.dispatchEvent(new Event('kto-vola'))}
              className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-800 text-slate-300 ring-1 ring-slate-700 transition-colors hover:bg-slate-700 hover:text-white">
              <Phone size={16} />
            </button>
          )}

          {/* Nočný režim – pri baliacom stole v sklade, kde displej svieti do
              očí. Platí pre celý systém a pamätá si to tento počítač. */}
          <button title={nocny ? 'Denný režim' : 'Nočný režim'}
            onClick={() => setNocny((x) => !x)}
            className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-800 text-slate-300 ring-1 ring-slate-700 transition-colors hover:bg-slate-700 hover:text-white">
            {nocny ? <Sun size={16} /> : <Moon size={16} />}
          </button>

          {/* Ťahanie prstom. Na jednodotykovom displeji sa inak stránka
              posúva len tenkým posuvníkom na kraji – prstom sa naň mieri
              ťažko a pri krabici to stojí čas. Pamätá si to tento počítač. */}
          <button title={dotyk ? 'Ťahanie prstom je zapnuté' : 'Zapnúť ťahanie prstom'}
            onClick={() => setDotyk((x) => !x)}
            className={`flex h-9 w-9 items-center justify-center rounded-lg ring-1 transition-colors ${
              dotyk
                ? 'bg-brand-600 text-white ring-brand-500'
                : 'bg-slate-800 text-slate-300 ring-slate-700 hover:bg-slate-700 hover:text-white'}`}>
            <Hand size={16} />
          </button>

          {/* .557 Rýchla aktualizácia – len administrátor. */}
          {user.role === 'admin' && <RychlaAktualizacia />}

          {/* Celá obrazovka: to isté, čo F11, len po ruke aj na dotykovom
              displeji, kde klávesnica nie je. */}
          <button title={naCelu ? 'Zmenšiť okno' : 'Na celú obrazovku'}
            onClick={() => celaObrazovka(!naCelu)}
            className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-800 text-slate-300 ring-1 ring-slate-700 transition-colors hover:bg-slate-700 hover:text-white">
            {naCelu ? <Minimize2 size={16} /> : <Maximize2 size={16} />}
          </button>
          </div>

          {/* Kredit AI (.524) – len administrátor. */}
          {user.role === 'admin' && <AiKredit />}
          <button className="mb-2 w-full rounded-lg px-2 py-1 text-left text-xs hover:bg-slate-800"
            onClick={() => setProfil(true)} title="Heslo a podpis do mailov">
            <div className="font-medium text-white">{user.name}</div>
            <div className="text-slate-400">{ROLA_POPIS[user.role] || 'Používateľ'} · môj profil</div>
          </button>
          <button className="btn w-full text-slate-300 hover:bg-slate-800 hover:text-white" onClick={logout}>
            <LogOut size={16} /> Odhlásiť sa
          </button>
        </div>
      </aside>

      <MojProfil open={profil} onClose={() => setProfil(false)} />
      {/* .550 „Odkliknite vybavené objednávky" – len vybraným ľuďom. */}
      <PripomienkaObjednavok user={user} />
      {/* .580 nové produkty z Autoimportu čakajú na schválenie – len admin */}
      <NoveProduktyPripomienka user={user} />
      {/* .651 vysúvacia lišta „Posledné faktúry" – všade, pre celý tím (predtým len v ESHOP) */}
      {!kiosk && ['admin', 'user', 'obchodnik'].includes(user.role) && <PosledneFakturyLista />}

      {menuOpen && (
        <div className={`fixed inset-0 z-30 bg-slate-900/40 ${kiosk ? '' : 'lg:hidden'}`}
          onClick={() => setMenuOpen(false)} />
      )}

      <div className="min-w-0 flex-1">
        <header className={`sticky top-0 z-20 flex h-14 items-center gap-3 border-b border-slate-200 bg-white/90 px-4 backdrop-blur no-print ${
          kiosk ? 'hidden' : 'lg:hidden'}`}>
          <button onClick={() => setMenuOpen(true)}><Menu size={22} /></button>
          {/* na svetlej hlavičke ide červená verzia; keby chýbala, ostane nápis */}
          <img src="/uploads/logo-steps-cervene.png" alt="STEPS STORE" className="h-5 w-auto"
            onError={(e) => { e.currentTarget.replaceWith(Object.assign(document.createElement('span'), { className: 'font-semibold', textContent: 'Firemný systém' })); }} />
          {/* Rýchle hľadanie (.466). Lupa je tu preto, že horná lišta je na
              telefóne aj tak takmer prázdna – a cesta do sekcie cez hamburger
              je dlhá práve vtedy, keď má človek číslo pred sebou. */}
          <button className="ml-auto rounded p-1.5 text-slate-600 active:bg-slate-100"
            onClick={() => setHladanie(true)} title="Hľadať">
            <SearchIcon size={20} />
          </button>
        </header>

        {/* Dochádzajúce miesto na serveri. Ide nad obsah a cez celú šírku –
            je to blížiaci sa výpadok práce, nie položka v nastaveniach. */}
        <MiestoNaDisku />

        {/* Schránka ide cez celú šírku: číta sa v nej komunikácia a píšu maily,
            a orezaná na 1400 px zbytočne plytvala miestom po stranách. */}
        {/* `pb-20` na úzkej obrazovke je miesto pod spodnú lištu (.465).
            Bez neho by posledný riadok zoznamu skončil pod ňou a nedal by sa
            prečítať ani ťuknúť – a práve posledný riadok býva ten najnovší. */}
        <main className={`mx-auto ${kiosk ? 'max-w-none p-3 pb-28' : 'p-4 pb-24 max-md:px-3 max-md:pt-3 sm:p-6 sm:pb-20 lg:pb-6'} ${
          loc.pathname.startsWith('/schranka') || kiosk ? 'max-w-none' : 'max-w-[1400px]'}`}>
          <TlacovaStanicaBeh user={user} />
          {/* Keď stránka spadne, nech ostane aspoň menu a dá sa kliknúť inam. */}
          <ErrorBoundary kluc={loc.pathname}>
          {!smieNaCestu(user.role, loc.pathname, user.skryte_sekcie || [])
            ? <Navigate to={({ marketer: '/ziskovost', uctovnik: '/prijate-faktury' })[user.role] || '/'} replace />
            : (
          <Suspense fallback={<Loading />}>
          <Routes>
            {/* Nástenka je domovská obrazovka pre všetkých vrátane obchodného
                zástupcu – jeho čísla sú na nej kartami „Môj predaj",
                „Moje leady" a „Ponuky verzus objednávky". Marketér má vlastný
                úvod: nástenku síce vidí, ale zaujímajú ho marže. */}
            <Route path="/" element={
              user.role === 'marketer' ? <Navigate to="/ziskovost" replace />
                : user.role === 'uctovnik' ? <Navigate to="/prijate-faktury" replace />
                : domov ? <Navigate to={domov} replace /> : <Dashboard />} />
            {/* Sekcia zanikla, jej obsah je kartami na nástenke. Adresa ostáva
                funkčná – záložka, ktorá po aktualizácii skončí na chybe, je
                zbytočná strata času. */}
            <Route path="/predaj" element={<Navigate to="/" replace />} />
            <Route path="/leady" element={<Leady user={user} />} />
            {/* Štatistika predaja zástupcu. Je pod leadmi zámerne – je to
                pokračovanie tej istej práce a `/leady` už má správnu dvojicu
                rolí (admin a obchodný zástupca). Statická cesta má v React
                Routeri prednosť pred `/leady/:id`, takže sa neberie ako číslo
                leadu. Kto koho vidí, rozhoduje server. */}
            <Route path="/leady/statistika" element={<Vykonnost />} />
            <Route path="/leady/provizia" element={<Provizia />} />
            <Route path="/leady/:id" element={<LeadDetail user={user} />} />
            <Route path="/objednavky" element={<Orders user={user} />} />
            {/* .908 key: každé „Nová objednávka" = čistý formulár (objednávka sa ukladá hneď a adresa sa mení bez navigácie) */}
            <Route path="/objednavky/nova" element={<OrderEdit key={loc.key} user={user} />} />
            <Route path="/objednavky/:id" element={<OrderEdit user={user} />} />
            <Route path="/ponuky" element={<Quotes />} />
            <Route path="/ponuky/nova" element={<QuoteEdit user={user} />} />
            <Route path="/ponuky/:id" element={<QuoteEdit user={user} />} />
            <Route path="/zakaznici" element={<Customers />} />
            <Route path="/partneri" element={<Partneri />} />
            <Route path="/partneri/nahlad/:id" element={<PartnerNahlad />} />
            <Route path="/na-objednanie" element={<Purchasing />} />
            <Route path="/prijem-faktur" element={<Invoices />} />
            {/* Objednávka od zákazníka v PDF. Rovnako ako Príjem faktúr to nie je
                zastávka v menu – chodí sa sem zo Schránky, od prílohy. */}
            <Route path="/objednavky-z-pdf" element={<ObjednavkyZPdf />} />
            <Route path="/objednavky-z-pdf/:id" element={<ObjednavkyZPdf />} />
            <Route path="/prijem-tovaru" element={<Prijem />} />
            <Route path="/rozvoz-tovaru" element={<RozvozTovaru />} />
            <Route path="/stepsync" element={<StepSync />} />
            <Route path="/balenie" element={
              <Balenie
                user={user}
                bezCelej={user.role === 'admin'}
                onMenu={() => setMenuOpen(true)}
                nocny={nocny}
                onNocny={() => setNocny((x) => !x)}
                dotyk={dotyk}
                onDotyk={() => setDotyk((x) => !x)}
                naCelu={naCelu}
                onCelu={() => celaObrazovka(!naCelu)}
              />} />
            <Route path="/servis" element={<Claims />} />
            <Route path="/servis/nova" element={<ClaimNew />} />
            <Route path="/servis/:id" element={<ClaimDetail />} />
            <Route path="/servisne-zmluvy" element={<ServisneZmluvy />} />
            <Route path="/stroje-zakaznikov" element={<StrojeZakaznikov />} />
            <Route path="/vozidla" element={<Vozidla />} />
            <Route path="/pripomienky" element={<Pripomienky />} />
            <Route path="/servisne-zmluvy/:id" element={<ServisnaZmluvaDetail />} />
            <Route path="/pozicovna" element={<Pozicovna />} />
            <Route path="/schranka" element={<Schranka />} />
            <Route path="/eshop/*" element={<Eshop />} />
            <Route path="/fakturacia" element={<Fakturacia />} />
            <Route path="/fakturacia/nova" element={<FakturaEdit />} />
            <Route path="/fakturacia/:id" element={<FakturaEdit />} />
            <Route path="/navod" element={<Pomoc />} />
            <Route path="/katalogy" element={<Catalog user={user} />} />
            <Route path="/davkovanie" element={<DavkovanieChemie />} />
            <Route path="/feedy" element={<Feedy user={user} />} />
            <Route path="/autoimport" element={<Autoimport />} />
            <Route path="/hydroflex" element={<HydroflexObjednavky />} />
            <Route path="/autoimport/nove" element={<Navigate to="/dielna/nove" replace />} />
            <Route path="/cenniky" element={<Cenniky user={user} />} />
            {/* Marketér tieto dve obrazovky **pozerá**. Server mu zápis
                odmietne tak či tak; `lenPozeram` je preto, aby mu na ne
                obrazovka neponúkala tlačidlá, ktoré skončia červenou. */}
            {/* .797 Financie a ceny – rozcestník a spoločná lišta nad sekciami. */}
            <Route element={<FinancieRam user={user} />}>
              <Route path="/financie" element={<Financie user={user} />} />
              <Route path="/ziskovost" element={<Ziskovost />} />
              <Route path="/dielna" element={<Dielna />} />
              <Route path="/heureka" element={<Heureka />} />
              <Route path="/vyhladavanie" element={<Vyhladavanie />} />
              <Route path="/dielna/rebrik" element={<Dielna />} />
              <Route path="/dielna/nova-karta" element={<Dielna />} />
              <Route path="/dielna/predane" element={<Dielna />} />
              <Route path="/dielna/doobjednat" element={<Dielna />} />
              <Route path="/dielna/nove" element={<Dielna />} />
              <Route path="/zarobky" element={<Zarobky lenPozeram={user.role === 'marketer'} />} />
            </Route>
            <Route path="/faktury-pohoda" element={<FakturyPohoda user={user} />} />
            {/* Návrh karty na e-shop. Otvára sa z príjmu, v menu položku nemá –
                je to krok v práci, nie sekcia, do ktorej sa chodí. */}
            <Route path="/nova-karta/:id" element={<NovaKarta />} />
            <Route path="/prijate-faktury" element={<PrijateFaktury user={user} />} />
            <Route path="/diely" element={<Diely />} />
            <Route path="/tovar" element={<Products user={user} />} />
            {/* Cenový rebrík sa presťahoval do dielne. Stará adresa ostáva
                funkčná – záložka v prehliadači, ktorá po aktualizácii skončí
                na chybe, je zbytočná strata času. */}
            <Route path="/tovar/ceny" element={<Navigate to="/dielna/rebrik" replace />} />
            <Route path="/sklad" element={<Sklad />} />
            <Route path="/sklad/nazvy" element={<Nazvy />} />
            <Route path="/sklad/jednotky" element={<Jednotky />} />
            {/* Rýchla inventúra telefónom (.467). Je pod Skladom, lebo je to
                tá istá práca – len s telefónom v ruke pri regáli namiesto
                pípača a počítača. */}
            <Route path="/sklad/rychla" element={<RychlaInventura />} />
            <Route path="/sklad/odbyt" element={<Odbyt />} />
            <Route path="/sklad/analyza" element={<AnalyzaPohody />} />
            <Route path="/zasielky" element={<Zasielky />} />
            <Route path="/vykon" element={<Vykon />} />
            <Route path="/nastavenia" element={<Settings user={user} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </Suspense>
          )}
          </ErrorBoundary>
        </main>
        {/* Tímový chat a upozornenia – malé okno vpravo dole (.449). Pri
            baliacom stole (kiosk) nie – tam sa pracuje prstami a zavadzalo by. */}
        {!kiosk && <TimOkno user={user} />}
        {!kiosk && <KtoVola user={user} />}
        {/* Skratka na štyri sekcie, ktoré sa na telefóne otvárajú najviac
            (.465). Na kiosku nie – baliaci stôl má vlastné ovládanie dole. */}
        {!kiosk && <RychleHladanie open={hladanie} onClose={() => setHladanie(false)} />}
        {!kiosk && (
          <SpodnaLista
            user={user}
            smie={(cesta) => smieNaCestu(user.role, cesta, user.skryte_sekcie || [])}
            onMenu={() => setMenuOpen(true)}
          />
        )}
      </div>
    </div>
  );
}
